export default __webpack_public_path__ + "images/feea1246a8f74a2854fd22344b431727-television_small.webp";